import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';

let UiCAcceptContentComponent = class UiCAcceptContentComponent {
    constructor() {
        this.isBack = true;
        this.isPartner = true;
        this.onChange = new EventEmitter();
        this.gotoLink = new EventEmitter();
        this.contractCheckBox = new EventEmitter();
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
    }
    goTo() { this.gotoLink.emit(); }
    acceptContract(event) { this.contractCheckBox.emit(event); }
    onChangeForm() { this.onChange.emit(this.contractForm); }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        this.continue.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAcceptContentComponent.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAcceptContentComponent.prototype, "isPartner", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "companyName", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "document", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "identifier", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAcceptContentComponent.prototype, "accept", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAcceptContentComponent.prototype, "ionCheckbox", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCAcceptContentComponent.prototype, "contractForm", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAcceptContentComponent.prototype, "onChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAcceptContentComponent.prototype, "gotoLink", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAcceptContentComponent.prototype, "contractCheckBox", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAcceptContentComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAcceptContentComponent.prototype, "continue", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "secondaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "titleForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "descriptionForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "primaryColorForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "secondaryColorForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAcceptContentComponent.prototype, "company", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAcceptContentComponent.prototype, "wlName", void 0);
UiCAcceptContentComponent = __decorate([
    Component({
        selector: 'ui-c-accept-content',
        template: "<div id=\"contract\">\n  <ui-c-header-onboarding [isBack]=\"isBack\" [isPartner]=\"isPartner\"\n    [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\" [title]=\"title\" [description]=\"description\" [name]=\"name\"\n    [companyName]=\"companyName\" [document]=\"document\" [identifier]=\"identifier\" [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\"\n    (back)=\"goBack()\">\n  </ui-c-header-onboarding>\n  <ion-row class=\"contract-content w-95 ion-justify-content-center ion-align-items-center\">\n    <ng-content></ng-content>\n  </ion-row>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCAcceptContentComponent);

let UiCAcceptContentModule = class UiCAcceptContentModule {
};
UiCAcceptContentModule = __decorate([
    NgModule({
        declarations: [UiCAcceptContentComponent],
        imports: [
            IonicModule,
            ReactiveFormsModule,
            CommonModule,
            UiBsTranslateModule,
            UiCButtonModule,
            UiCHeaderOnboardingModule
        ],
        exports: [UiCAcceptContentComponent]
    })
], UiCAcceptContentModule);

export { UiCAcceptContentComponent, UiCAcceptContentModule };
//# sourceMappingURL=wlp-ui-c-accept-content.js.map
